export function getStartPageUrl(language) {
  switch (language) {
    case 'sv':
      return 'https://join.lifesum.com/c/229?campaignId=229'
    case 'de':
      return 'https://join.lifesum.com/c/231?campaignId=231'
    case 'no':
      return 'https://join.lifesum.com/c/232?campaignId=232'
    case 'da':
      return 'https://join.lifesum.com/c/233?campaignId=233'
    case 'en':
      return 'https://join.lifesum.com/c/230?campaignId=230'
    default:
      return 'https://app.adjust.com/112zb57z_116hd4yn'
  }
}
